import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

export const authGuard: CanActivateFn = () => {
  const token = localStorage.getItem('hub_access_token');
  return token ? true : inject(Router).createUrlTree(['/auth/login']);
};
